// extracted by mini-css-extract-plugin
module.exports = {"flexSpacer":"_2FLIy"};